<template>
  <v-dialog
    v-model="show"
    hide-overlay
    fullscreen
    transition="dialog-bottom-transition"
  >
    <div id="app">
      <v-app id="inspire">
        <v-card>
          <div class="row" style="margin:20px">
            <v-carousel height="550">
              <v-carousel-item
                v-for="(item, i) in listadofoto"
                :key="i"
                :src="item.path"
                contain
                max-height="450px"
                reverse-transition="fade-transition"
                transition="fade-transition"
                title="item.titulo"
                @click="votarfoto(item.titulo, item.path)"
              >
                <v-row @click="votarfoto(item.titulo, item.path)">
                  <div style="margin:20px">
                    <font color="#000000" face="Arial" size="3">{{
                      item.titulo
                    }}</font>
                  </div>
                </v-row>
              </v-carousel-item>
            </v-carousel>
          </div>
        </v-card>
        <EditarVotacion
          :visible="showInforme"
          :foto="this.foto"
          :path="this.path"
          @close="showInforme = false"
        ></EditarVotacion>
      </v-app>
    </div>
  </v-dialog>
</template>

<script>
import router from "../../../src/router/index";
import axios from "../../../src/axios-auth";
import EditarVotacion from "../Extras/Votacionalmanaque.vue";

export default {
  components: { EditarVotacion },
  data: (vm) => ({
    valid: false,
    lazy: false,
    listadofoto: [],
    visible: true,
    showInforme: false,
    foto: "",
    path: "",
  }),

  computed: {
    show: {
      get() {
        this.buscarFotos();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarInforme();
          console.log("cerrado");
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    votarfoto(foto, path) {
      console.log("VOTÓ FOTO N°: " + foto + " PATH " + path);
      this.foto = foto;
      this.path = path;
      this.showInforme = true;
    },
    vaciarInforme() {
      this.listadofoto = [];
    },
    buscarFotos() {
      this.vaciarInforme();

      let self = this;
      axios
        .get("/Icssa/CargarFotosAlmanaque?")
        .then((response) => {
          self.listadofoto = response.data;
          //console.log("FOTOS: " + listado[1].path);
        })
        .catch((error) => {
          self.listadofoto = [];
          console.log(error);
        });
    },
  },
};
</script>
